export default __webpack_public_path__ + "static/media/person_profile.67b2d0a7.svg";